import React, { useState } from "react";
import { Button, Modal } from "../../design-system/components";

import "./style/CommonModal.css";

/**
 * Thin app-level wrapper kept for backwards compatibility — new code should
 * use the design-system Modal directly.
 */
const CommonModal = ({ open, handleClose, title, actions, children }) => {
  return (
    <Modal open={open} onClose={handleClose} title={title} actions={actions}>
      {children}
    </Modal>
  );
};

export function DeleteDialog({
  isOpen,
  onDelete,
  conversationList,
  handleClose,
}) {
  return (
    <Modal
      open={isOpen}
      onClose={() => handleClose()}
      title="Are you sure you want to delete?"
      size="sm"
      actions={
        <>
          <Button variant="outline" size="sm" onClick={() => handleClose()}>
            Cancel
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={() => onDelete()}
            disabled={conversationList.length === 0}
          >
            Delete
          </Button>
        </>
      }
    >
      <div className="delete-converstions-list--wrapper">
        {conversationList.length === 0 ? (
          <h3>There is no conversation available to delete.</h3>
        ) : (
          conversationList.map((elm, i) => (
            <div key={`${i}`} className="delete-conversation-elm--wrapper">
              <p>{elm.name}</p>
            </div>
          ))
        )}
      </div>
    </Modal>
  );
}

/** Max mirrors Conversation.name on the backend. */
export const CONVERSATION_NAME_MAX_LENGTH = 255;

export function RenameDialog({ isOpen, currentName, onRename, handleClose }) {
  const [name, setName] = useState(currentName ?? "");
  const trimmed = name.trim();
  // Nothing to save for an empty title or one the user left untouched.
  const canSave = trimmed.length > 0 && trimmed !== currentName;

  const submit = (event) => {
    event.preventDefault();
    if (!canSave) return;
    onRename(trimmed);
  };

  return (
    <Modal
      open={isOpen}
      onClose={() => handleClose()}
      title="Rename chat"
      size="sm"
      actions={
        <>
          <Button variant="outline" size="sm" onClick={() => handleClose()}>
            Cancel
          </Button>
          <Button
            variant="primary"
            size="sm"
            onClick={submit}
            disabled={!canSave}
          >
            Save
          </Button>
        </>
      }
    >
      <form onSubmit={submit}>
        <label className="rename-conversation-label" htmlFor="rename-chat-name">
          Chat name
        </label>
        <input
          id="rename-chat-name"
          className="rename-conversation-input"
          type="text"
          value={name}
          autoFocus
          maxLength={CONVERSATION_NAME_MAX_LENGTH}
          onChange={(event) => setName(event.target.value)}
        />
        {/* Submits on Enter without adding a second visible button. */}
        <button type="submit" hidden aria-hidden="true" tabIndex={-1} />
      </form>
    </Modal>
  );
}

export default CommonModal;
